import "./modules/global";

document.addEventListener("DOMContentLoaded", () => {
	console.log("Login page loaded");
});
